export default "__VITE_ASSET__Bsj83CBv__"